module.exports = __webpack_public_path__ + "static/media/FAULT_ON.0539e796.png";